import React from "react";
import { useDrop } from "react-dnd";
import classes from "./style.module.css";

const ItemType = "marker";

const DropContainer = ({ children, addMarker, moveMarker }) => {
  const [, drop] = useDrop(() => ({
    accept: ItemType,
    drop: (item, monitor) => {
      const delta = monitor.getDifferenceFromInitialOffset();
      if (!delta) return;

      const left = Math.round(item.x + delta.x);
      const top = Math.round(item.y + delta.y);
      moveMarker(item.id, left, top);
      return undefined;
    },
  }));

  const handleOnClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    addMarker({ x, y });
  };

  return (
    <div ref={drop} onClick={handleOnClick} className={classes.dropContainer}>
      {children}
    </div>
  );
};

export default DropContainer;
